module.exports = __webpack_public_path__ + "static/block9-9e9cb42ba4837f636e4f66b5b968aa83.jpg";